import React from "react";
const Homepage = () => {
  return (
    <>
      <i className="bi bi-list mobile-nav-toggle d-xl-none"></i>

      {/*  <!-- ======= Header ======= --> */}

      {/* <!-- End Header --> */}

      {/* <!-- ======= Hero Section ======= --> */}

      {/* <!-- End Hero --> */}

      <main id="main">
        {/* <!-- ======= About Section ======= --> */}

        {/* <!-- End About Section --> */}

        {/* <!-- ======= Facts Section ======= --> */}

        {/* <!-- End Facts Section --> */}

        {/* <!-- ======= Skills Section ======= --> */}

        {/* <!-- End Skills Section --> */}

        {/* <!-- ======= Resume Section ======= --> */}

        {/* <!-- End Resume Section -->
 
     <!-- ======= Portfolio Section ======= --> */}

        {/* <!-- End Portfolio Section --> */}

        {/* <!-- ======= Services Section ======= --> */}

        {/* <!-- End Services Section --> */}

        {/* <!-- ======= Testimonials Section ======= --> */}

        {/* <!-- End Testimonials Section --> */}

        {/* <!-- ======= Contact Section ======= --> */}
      </main>

      {/* <!-- End  Footer --> */}

      <a
        href="#"
        className="back-to-top d-flex align-items-center justify-content-center"
      >
        <i className="bi bi-arrow-up-short"></i>
      </a>
    </>
  );
};

export default Homepage;
